<template>
    <div class="flex justify-end mt-10">
        <div class="flex gap-4">
            <BaseButton
                v-if="!hideCancelButton"
                :disabled="loading"
                @click="emits('cancel', $event)">
                <span v-if="!loading">{{ $t(cancelLabel) }}</span>
                <span v-else>
                    <LoadingSpinner />
                </span>
            </BaseButton>

            <BaseButton
                v-if="showRemoveButton"
                color="danger"
                :disabled="loading || (validation ? !!Object.keys(validation.errors).length : false)"
                shortcut="meta_backspace"
                @mouseenter="validation ? validation.validate() : null"
                @click="emits('remove', $event)">
                <span v-if="!loading">{{ $t(removeLabel) }}</span>
                <span v-else>
                    <LoadingSpinner />
                </span>
            </BaseButton>
        </div>

        <div
            v-if="!hideSubmitButton"
            class="inline-flex">
            <BaseButton
                class="whitespace-nowrap"
                :class="{'rounded-r-none': showCreateButton,'ml-4':showRemoveButton || !hideCancelButton}"
                :disabled="loading || (validation ? !!Object.keys(validation.errors).length : false)"
                type="submit"
                color="primary"
                shortcut="meta_s"
                @click="emits('submit', $event)"
                @mouseenter="validation ? validation.validate() : null">
                <span v-if="!loading">{{ $t(submitLabel) }}</span>
                <span v-else>
                    <LoadingSpinner />
                </span>
            </BaseButton>

            <Menu
                v-if="showCreateButton"
                as="div"
                class="relative block">
                <MenuButton>
                    <BaseButton
                        class="px-2 rounded-l-none"
                        color="primary"
                        :disabled="loading || (validation ? !!Object.keys(validation.errors).length : false)"
                        @mouseenter="validation ? validation.validate() : null">
                        <Icon
                            name="chevron-down"
                            size="5"
                            aria-hidden="true" />
                    </BaseButton>
                </MenuButton>
                <Transition
                    enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95">
                    <MenuItems
                        class="absolute right-0 z-10 w-max origin-top-right rounded-r-md shadow-lg focus:outline-none">
                        <div class="mt-1">
                            <MenuItem>
                                <BaseButton
                                    color="primary"
                                    :disabled="loading || (validation ? !!Object.keys(validation.errors).length : false)"
                                    @click="emits('create', $event)"
                                    @mouseenter="validation ? validation.validate() : null">
                                    <span v-if="!loading">{{ $t(createLabel) }}</span>
                                    <span v-else>
                                        <LoadingSpinner />
                                    </span>
                                </BaseButton>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </Transition>
            </Menu>
        </div>
    </div>
</template>

<script setup>
defineProps({
    loading: {type: Boolean, default: false},
    validation: {type: Object, default: null},
    hideCancelButton: {type: Boolean, default: false},
    hideSubmitButton: {type: Boolean, default: false},
    showRemoveButton: {type: Boolean, default: false},
    showCreateButton: {type: Boolean, default: false},
    cancelLabel: {type: String, default: 'abort'},
    submitLabel: {type: String, default: 'save'},
    removeLabel: {type: String, default: 'delete'},
    createLabel: {type: String, default: 'saveAndContinue'}
})

const emits = defineEmits(['cancel', 'submit', 'remove', 'create'])
</script>
